export enum AlertType {
  Success = 'success',
  Error = 'error',
  Info = 'info',
  Normal = '',
}

export interface IAlert {
  /** Stable key of the toast (an incrementing counter). */
  id: number;
  message: string;
  type: AlertType;
  action?: {
    text: string;
    cb: () => void;
  };
}
